import * as React from "react";
const SvgFaceSmile = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 12a8.965 8.965 0 1 0-17.93 0A8.965 8.965 0 0 0 12 20.965 8.965 8.965 0 0 0 20.965 12M7.379 13.172a1.035 1.035 0 0 1 1.445.202l.005.006.033.04q.05.062.159.177c.146.152.365.36.65.566.573.417 1.364.802 2.329.802s1.756-.385 2.33-.802a5 5 0 0 0 .808-.742l.033-.041.005-.006a1.035 1.035 0 0 1 1.652 1.247L16 14l.827.622v.002l-.004.004-.008.01a2 2 0 0 1-.091.113 6.98 6.98 0 0 1-1.178 1.086c-.802.583-2.01 1.198-3.546 1.198-1.535 0-2.744-.615-3.546-1.198a7 7 0 0 1-1.178-1.086l-.091-.113-.008-.01-.003-.004-.001-.002S7.172 14.621 8 14l-.828.621a1.035 1.035 0 0 1 .207-1.45M9 7.465a1.535 1.535 0 1 1 0 3.07 1.535 1.535 0 0 1 0-3.07m6 0a1.535 1.535 0 1 1 0 3.07 1.535 1.535 0 0 1 0-3.07M23.035 12c0 6.095-4.94 11.035-11.035 11.035S.965 18.095.965 12 5.905.965 12 .965 23.035 5.905 23.035 12"
}));
export default SvgFaceSmile;
//# sourceMappingURL=FaceSmile.js.map